import React__default from 'react';
import Typography from '../../Typography/Typography.js';

var VARIANT_CONFIG = {
  large: 'body-short-01',
  medium: 'body-short-02'
};
var defaultOptionLabelRenderer = function defaultOptionLabelRenderer(label, state, size) {
  var variant = VARIANT_CONFIG[size];
  return /*#__PURE__*/React__default.createElement(Typography, {
    className: "truncate",
    color: state.selected ? 'text-text-primary' : 'text-text-secondary',
    variant: variant
  }, label);
};
var defaultTagLabelRenderer = function defaultTagLabelRenderer(label, size) {
  var variant = VARIANT_CONFIG[size];
  return /*#__PURE__*/React__default.createElement(Typography, {
    className: "truncate",
    color: "text-text-primary",
    variant: variant
  }, label);
};

export { defaultOptionLabelRenderer, defaultTagLabelRenderer };
//# sourceMappingURL=renderers.js.map
